import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { path } from 'ramda';
import { Button } from '@invent/wl-ui-kit';
import { useQueryData } from '@invent/platform-api';
import { usePlatformWidgetsLoadedSelector } from '@/src/domains/widgets/selectors';
import { Preload } from '..';
import { BlankPageError } from './components/blank';

const getHomeDashboard = (data: any) => {
  const dashboardId = path(['result', 0, 'meta', 'id'], data);

  if (dashboardId) {
    return `/dashboard/${dashboardId}`;
  }

  return '/';
};

interface IFallbackPage404Props {
  title?: string;
  explanation?: string;
}

export const FallbackPage404 = ({
  title = 'We could not find this page',
  explanation = "Please doublecheck that link is spelled correctly or try using search. Contact us if you still can't find what you need."
}: IFallbackPage404Props) => {
  const history = useHistory();
  const metaLoaded = usePlatformWidgetsLoadedSelector();
  const { data } = useQueryData(['navigation', 'defaultDashboard']);
  const homeDashpoardUrl = useMemo(() => getHomeDashboard(data), [data]);
  const handleRedirectAllDashboards = () => history.push('/dashboards/fast-view');
  const handleRedirectHomeDashboard = () => history.push(homeDashpoardUrl);

  const actions = [
    <Button
      role="link"
      key="all-dashboards"
      text="View All Dashboards"
      onClick={handleRedirectAllDashboards}
      variant="outline"
    />,
    <Button
      role="link"
      key="home-dashboard"
      text="Back to Home"
      onClick={handleRedirectHomeDashboard}
      variant="outline"
    />
  ];

  if (!metaLoaded) {
    return <Preload />;
  }

  return (
    <BlankPageError
      iconName="page_view"
      mainTitle={title}
      explanation={explanation}
      actions={actions}
    />
  );
};
